import React, { Component } from 'react';

// Styles
import './quem-somos.scss';

// Components

import Desenvolvimento from '../desenvolvimento/index';

export default class QuemSomos extends Component {
    render() {
        return (
            <Desenvolvimento />
        )
    }
}